﻿export { default } from './combine';
